import React from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { HashLink as LinkHash } from 'react-router-hash-link';
import LoaderCP from 'components/loader';
import { MEMBER_URL } from '../../constants/Constants';

const Header = ({ user, status }) => {
  const handleOutSesion = () => {
    Cookies.remove('jwt_clubpremier');
    window.location.href = `${MEMBER_URL}/salir`;
  };

  const renderSessionActive = () => {
    return (
      <div className="row text-center">
        {
          status === 'pending' ? (
            <div className="loader-cp container">
              <LoaderCP />
            </div>
          ) : (
            <>
              <Col lg={7}>
                <div className="header-group logged-in">
                  <div className="userinfo">
                    <h5>{`¡Hola ${user.name}!`}</h5>
                    <p className="small">
                      No. de Cuenta:
                      <strong>{user.activeCardNo}</strong>
                      {`| Saldo: ${user.points} Puntos Aeroméxico Rewards`}
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={5}>
                <div>
                  <button type="button" className="btn btn-secondary-dark btn-sm" onClick={handleOutSesion}>
                    Cierra sesión
                  </button>
                </div>
              </Col>
            </>
          )
        }
      </div>
    );
  };

  const renderNotSession = () => {
    return (
      <Form className="header-group login row" action={`${MEMBER_URL}/login/auth`} noValidate method="POST">
        <Col lg={3} className="px-2">
          <input id="autologin" type="hidden" name="autologin" value="true" />
          <input id="url" type="hidden" name="url" value={MEMBER_URL} />
          <div className="form-group login-account-group">
            <input
              className="form-control form-header"
              id="login-account"
              name="j_username"
              required
              placeholder="No. Cuenta Rewards" />
            <span className="form-text small">
              <a href="https://member.aeromexicorewards.com/individual/recuperacuenta" className="text-white">Recuperar tu No. de Cuenta</a>
            </span>
          </div>
        </Col>
        <Col lg={3} className="px-2">
          <div className="form-group login-password-group">
            <input
              className="form-control form-header"
              id="login-password"
              name="j_password"
              type="password"
              required
              placeholder="Contraseña" />
            <span className="form-text small">
              <a href="https://member.aeromexicorewards.com/recuperar-nip" className="text-white">Olvidé mi contraseña</a>
            </span>
          </div>
        </Col>
        <Col lg={3}>
          <button type="submit" className="btn-sm btn-secondary-dark login-button btn mx-15 mt-1">Inicia sesión</button>
        </Col>
        <Col lg={3} className="px-0">
          <a className="btn btn-primary-dark btn-sm mx-15 mt-1" href="https://member.aeromexicorewards.com/registro">Inscríbete</a>
        </Col>
      </Form>
    );
  };

  return (
    <div className="site-header">
      <Container>
        <Row className="py-15">
          <Col xs={8} lg={4} xl={3}>
            <img src="https://s3media.aeromexicorewards.com/clubpremierstyleguide/amstyleguide/images/am-rewards-white.svg" alt="logo" className="w-100 d-none d-md-block" />
            <img src="https://s3media.aeromexicorewards.com/clubpremierstyleguide/amstyleguide/images/am-rewards-blue.svg" alt="logo" className="w-100 d-block d-md-none" />
          </Col>
          <Col lg={3} className="d-none d-xl-block">
            <div className="header-group contact text-center">
              <LinkHash to="#contacto" className="contact-link" id="highlight-contact-info">
                <span className="fas fa-phone" />
              </LinkHash>
              <p className="small">Contacto</p>
            </div>
          </Col>
          <Col lg={6} className="d-none d-xl-block">
            {status === 'success' ? renderSessionActive() : renderNotSession() }
          </Col>
          <Col xs={6} md={6} lg={4} className="d-none d-lg-block d-xl-none text-center">
            { status === 'success'
              ? (
                <a className="btn btn-secondary-dark btn-sm mt-10" href="https://member.aeromexicorewards.com/login">
                  Cierra sesión
                </a>
              )
              : (
                <>
                  <button className="btn btn-secondary-dark btn-sm login-button mx-15" type="submit">Inicia sesión</button>
                  <a className="btn btn-primary-dark btn-sm mx-15" href="https://member.aeromexicorewards.com/registro">Inscríbete</a>
                </>
              )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Header.propTypes = {
  status: PropTypes.string.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    activeCardNo: PropTypes.string.isRequired,
    points: PropTypes.number.isRequired,
  }).isRequired,
};

export default Header;
